import axios from "axios";

export default  axios.create({
  baseURL: globalThis.config.Settings.ApiConfiguration.Host,
  headers: {
    "Content-type": "application/json"
  },
});
